module.exports = __webpack_public_path__ + "img/mirror21.78210a98.jpg";